const DefaultComponent = () => import('@/ui-overrides/default/pages/request/create/step_01.vue');


export default {
	name: 'Step01Wrapper',

	// needed for wizard steps
	tag: true,

	functional: true,

	render(h, context) {
		let component = DefaultComponent;

		const uiOverride = context.parent.$store.state.agency.default_ui;

		try {
			const override = require(`@/ui-overrides/${uiOverride}/pages/request/create/step_01.vue`);
			component = override.default;
		}
		catch (err) {
			context.parent.$log.debug(`No override found: ${err}`);
		}

		return h(
			component,
			context.data,
			context.children,
		);
	},
};
